class CachService {
  tempCache: string[] = [];
  tempCacheHashMap: Record<string, boolean> = {};

  add(urls: string | string[]) {
    const that = this;
    if (!urls) return;
    if (typeof urls === 'string') {
      if (typeof that.tempCacheHashMap[urls] === 'undefined') {
        that.tempCacheHashMap[urls] = true;
        that.tempCache.push(urls);
      }
    } else {
      urls.forEach(function (url) {
        if (typeof that.tempCacheHashMap[url] === 'undefined') {
          that.tempCacheHashMap[url] = true;
          that.tempCache.push(url);
        }
      });
    }
  }
}

export const cache = new CachService();
